
/* global Map: false, Promise: false */
/**
 * JavaScript Bootstrap.
 * @class SP.sitekit.Bootstrap
 */
SP.lang.Class.define("SP.sitekit.Bootstrap", {

	singleton: true,

	/**
	 * Mapping von data-Attribut zu Klasse
	 */
	_classes: null,

	/**
	 * Mapping von Instanz-Id zur Instanz
	 */
	_instanceMap: null,

	/**
	 * Map von Dom-Elementen die für die Zerstörung vorbereitet wurden.
	 * Nach einer Karenzzeit (coolingTime) werden diese Elemente dann
	 * endgültig zerstört
	 */
	_markedForDestruction: null,

	/**
	 * Anzahl der Bootstrap-Zyklen die bisher durchgeführt wurden
	 */
	_bootstrapCycles: 0,

	/**
	 * Anzahl der erzeugten Instanzen die gebootstrapped wurden
	 */
	_bootstrappedInstances: 0,

	/**
	 * Anzahl der zerstörten Instanzen
	 */
	_destroyedInstances: 0,

	/**
	 * Karenzzeit für die Zerstörug
	 */
	_coolingTime: 30000,

	/**
	 * MutationObserver der auf DOM-Änderungen reagiert
	 */
	_observer: null,

	/**
	 * Gibt an ob der MutationObserver gerade aktiv ist
	 */
	_observerIsStarted: false,

	/**
	 * Konstruktor
	 */
	init: function() {
		var me = this;
		me._classes = {};
		me._instanceMap = {};
		me._markedForDestruction = new Map();
		me._throttledBootstrap = SP.lang.Function.throttle(me.bootstrap, 50);
		SP.dom.Document.onReady(function() {
			if (MutationObserver) {
				// create an observer instance
				me._observer = new MutationObserver(function(mutations, observer) {
					for (var i = 0, len = mutations.length; i < len; i++) {
						var mutation = mutations[i];
						if (mutation.type === "childList") {
							me._processMutation(mutation);
						}
					}
				});
				me.startObserver();
			}
			me._throttledBootstrap();
		});
	},

	/**
	 * Führt den übergebenen Callback mit deaktivierten Mutation-Observer aus
	 * @param {Function} cb Callback der ausgeführt wird während der
	 * Observer deaktiviert ist
	 * @param {boolean} bootstrap (default = true) Soll nach dem
	 * Callback gebootstrapped werden?
	 */
	withNoObserver: function (cb, bootstrap) {
		this.stopObserver();
		cb.apply(this, []);
		this.startObserver();
		if (bootstrap === undefined || bootstrap === true) {
			this.bootstrap();
		}
	},

	/**
	 * Startet den Mutation-Observer
	 */
	startObserver: function () {
		if (this._observer && !this._observerIsStarted) {
			this._observer.observe(document.body, {
				childList: true,
				subtree: true,
				attributes: false,
				characterData: false
			});
			this._observerIsStarted = true;
		}
	},

	/**
	 * Stoppt den Mutation-Observer
	 */
	stopObserver: function () {
		if (this._observer && this._observerIsStarted) {
			this._observer.disconnect();
			this._observerIsStarted = false;
		}
	},

	/**
	 * @param {string} dataAttribute
	 * @return {Function}
	 */
	register: function(dataAttribute, className) {
		var me = this;
		var clazz;
		if (SP.isString(className)) {
			clazz = SP.lang.Object.resolve(window, className);
		} else {
			clazz = className;
		}
		if (!clazz) {
			console.error(new Error("Class '" + clazz + "' for data-Attribute '" + dataAttribute + "' not found"));
			return;
		}
		me._classes[dataAttribute] = clazz;
	},

	clearClasses: function () {
		var me = this;
		me._classes = [];
	},

	/**
	 * @param {HTMLElement} base
	 * @return {Number} Die Anzahl der gebootstrappten Elemente
	 */
	bootstrap: function(base) {
		if (!base) {
			base = document;
		}
		var me = this;
		var bootstrappedInstances = [];

		// Durch alle registrierten Klassen loopen
		SP.lang.Object.each(me._classes, function(dataAttribute, Clazz) {
			var domNodes = base.querySelectorAll("[" + dataAttribute + "]");

			SP.lang.Array.from(domNodes).forEach(function (el) {
				if (!el.hasAttribute(dataAttribute + "-bootstrapped")) {
					// TODO: Vielleicht ein beforeBootstrap-Event?
					var bootstrappedInstance = me._createInstance(el, dataAttribute, Clazz);
					if (bootstrappedInstance) {
						bootstrappedInstances.push({
							el: el,
							inst: bootstrappedInstance,
							type: dataAttribute
						});
					}
					me._markElementBootstrapped(el, dataAttribute, bootstrappedInstance);
				}
			});
		});

		// Die Bootstrap-Events werden erst nachdem kompletten
		// Bootstrap-Cycle getriggert, damit Komponenten die
		// zusammen gebootstrapped werden die chance haben
		// miteinander zu kommunizeren
		bootstrappedInstances.forEach(function (o) {
			var inst = o.inst;
			var el = o.el;
			var type = o.type;
			if (SP.isFunction(inst.finish)) {
				inst.finish();
			}
			SP.dom.Event.fireEvent(el, "bootstrap", {
				instance: inst,
				type: type
			});
		});

		me._bootstrapCycles++;
		return bootstrappedInstances.length;
	},

	/**
	 *
	 */
	info: function () {
		console.log("BootstrapCycles", this._bootstrapCycles);
		console.log("Bootstrapped Instances", this._bootstrappedInstances);
		console.log("Destroyed Instances", this._destroyedInstances);
	},


	/**
	 * @param {Object} inst
	 */
	destroyInstance: function (inst) {
		if (!inst) {
			return;
		}

		if (SP.isFunction(inst.destroy)) {
			inst.destroy();
		}
		this._markElementDestroyed(inst.__el, inst.__type, inst);
	},

	/**
	 *
	 * @param {HTMLElement} el
	 */
	destroyInstancesByElement: function (el) {
		var me = this;
		Object.keys(me._classes).forEach(function (dataAttribute) {
			var instId = el.getAttribute(dataAttribute + "-bootstrapped");
			if (instId !== null) {
				me.destroyInstance(me.getInstanceById(instId));
			}
		});
	},

	/**
	 * Gibt eine gebootstrappte Instanz anhand der Id zurück
	 * @param {string} id
	 * @return {Object|null}
	 */
	getInstanceById: function (id) {
		return this._instanceMap[id] || null;
	},

	/**
	 * Gibt eine gebootstrappte Instanz anhand eines HTML-Elementes
	 * und dem Typ zurück
	 * @param {HTMLElement} el
	 * @param {string} type
	 * @return {Object|null}
	 */
	getInstanceByElement: function (el, type) {
		if (this.isElementBootstrapped(el, type)) {
			return this.getInstanceById(el.getAttribute(type + "-bootstrapped"));
		}
		return null;
	},

	/**
	 * Prüft ob das übergebene Element mit dem übergebenen Typ
	 * gebootstrapped wurde
	 * @param {HTMLElement} el
	 * @param {string} type
	 * @return {boolean}
	 */
	isElementBootstrapped: function (el, type) {
		return el.hasAttribute(type + "-bootstrapped");
	},

	/**
	 * Ruft den übergebenen Callback auf, sobald der
	 * übergebene Typ auf dem HTML-Element gebootstrapped wurde
	 * @param {HTMLElement} el
	 * @param {string} type
	 * @param {Function} cb
	 * @return {Promise<Object>}
	 */
	whenElementIsBootstrapped: function (el, type, cb) {
		var me = this;
		return new Promise(function (resolve) {
			var inst = me.getInstanceByElement(el, type);
			if (inst !== null) {
				resolve(inst);
				if (cb) {
					cb.apply(me, [inst]);
				}
				return;
			}

			SP.dom.Event.on(el, "bootstrap", function (e) {
				if (type === e.detail.type) {
					resolve(e.detail.instance);
					if (cb) {
						cb.apply(me, [e.detail.instance]);
					}
					return;
				}
			}, {
				once: true
			});
		});
	},

	/**
	 * Markiert ein Element als Bootstrapped. Wenn bei Inst keine Instanz
	 * übergeben wird, wird angenommen, dass das Bootstrapping der Komponente
	 * fehlgeschlagen ist. In diesem Fall wird das HTMLElement trotzdem als
	 * bootstrapped markiert, damit beim nächsten Bootstrapping nicht erneut versucht
	 * wird die Instanz zu erzeugen
	 */
	_markElementBootstrapped: function (el, dataAttribute, inst) {
		var id = null;
		if (inst && inst.__id) {
			id = inst.__id;
		}
		el.setAttribute(dataAttribute + "-bootstrapped", id);
		if (inst) {
			this._instanceMap[inst.__id] = inst;
			this._bootstrappedInstances++;
		}
	},

	/**
	 * Markiert ein Element zerstört.
	 */
	_markElementDestroyed: function (el, dataAttribute, inst) {
		el.removeAttribute(dataAttribute + "-bootstrapped");
		delete this._instanceMap[inst.__id];
		this._destroyedInstances++;
	},

	/**
	 * Erzeugt eine einzelne Instanz anhand des übergebenen Elementes,
	 * dem Namen des Data-Attributs und einer Referenz auf die Klasse
	 * die erzeugt werden soll
	 * @param el HTMLElement
	 * @param dataAttribute string
	 * @param Clazz function
	 */
	_createInstance: function (el, type, Clazz) {
		try {
			var data = el.getAttribute(type);
			var inst = new Clazz(el, (data !== "" ? JSON.parse(data) : {}));
			inst.__id = SP.generateId("sp");
			inst.__el = el;
			inst.__type = type;
			return inst;
		} catch (error) {
			console.groupCollapsed("%c Error bootstrapping data-Attribute \"" + type + "\"", "color:white;background:red;");
			console.log(el);
			console.error(error);
			console.groupEnd();
		}
	},

	/**
	 * Bereitet ein HTML-Element und dessen gebootstrappte Instanzen
	 * auf deren Zerstöung vor. Wenn das HTMLElement nach einer
	 * Karenzzeit immer noch von DOM-Baum getrennt ist, wird
	 * das HTMLElement inklusiver gebundener Instanzen zerstört.
	 *
	 * Sollte das Element nach der Karenzzeit wieder im DOM-Baum
	 * vorhanden sein, wird die Element-Zerstörung abgebrochen
	 * @param {HTMLElement} el
	 */
	_prepareForDestruction: function (el) {
		var me = this;
		clearTimeout(me._markedForDestruction.get(el));
		me._markedForDestruction.set(el, setTimeout(function () {
			if (document.body.contains(el)) {
				me._remidyDestruction(el);
			} else {
				me.destroyInstancesByElement(el);
			}
			me._markedForDestruction.delete(el);
		}, me._coolingTime));
	},

	/**
	 * Lösch-Timer zurückgesetzen und das Element aus
	 * der Liste der zu zerstörenden Elemente entfernen.
	 * Dies kann bei Verschiebe-Aktionen von Dom aufteten.
	 * @param {HTMLElement} el
	 */
	_remidyDestruction: function (el) {
		var me = this;
		me._clearDestructionMark(el);
		me._updateElementBootstrappedAttributes(el);
	},

	/**
	 * Geht die vorhandenen Instanzen durch und überprüft
	 * ob diese noch mit dem DOM-Baum verbunden sind.
	 * Sollte dies nicht mehr der Fall sein, wird der
	 * Lösch-Prozess für die entsprechende Instanz angestoßen
	 */
	_prepareDetachedInstancesForDestruction: function () {
		var me = this;
		SP.lang.Object.each(me._instanceMap, function (id, instance) {
			if (!document.body.contains(instance.__el)) {
				me._prepareForDestruction(instance.__el);
			}
		});
	},

	/**
	 *
	 */
	_processMutation: function (mutation) {
		var me = this;

		// In den gelöschten Dom-Knoten nach gebootstrapten Komponenten suchen
		// um diese für die zerstörung zu markieren
		if (mutation.removedNodes.length > 0) {
			me._prepareDetachedInstancesForDestruction();
		}
		/*
		var i, len, el;
		for (i = 0, len = mutation.removedNodes.length; i < len; i++) {
			el = mutation.removedNodes[i];
			if (el instanceof HTMLElement) {
				var toRemove = me._findBootstrappedIn(el);
				for (var j = 0, jlen = toRemove.length; j < jlen; j++) {
					me._prepareForDestruction(toRemove[j]);
				}
			}
		}
		*/

		// In den hinzugefügten Elementen nach Elementen suchen die schon als gelöscht vormarkiert wurden
		// aber noch nicht zerstört worden sind wenn die Karenzzeit noch nicht abgelaufen ist.
		// Wenn solch ein Element gefunden wurde, wird der Lösch-Timer zurückgesetzt und das Element aus
		// der Liste der zu zerstörenden Elemente entfernt.
		// Dies kann bei Verschiebe-Aktionen von Dom aufteten.
		/*
		for (i = 0, len = mutation.addedNodes.length; i < len; i++) {
			el = mutation.addedNodes[i];
			if (el instanceof HTMLElement) {
				var toRemidy = me._findBootstrappedIn(el);
				for (var j = 0, jlen = toRemidy.length; j < jlen; j++) {
					me._clearDestructionMark(toRemidy[j]);
					me._verifyElement(toRemidy[j]);
				}
			}
		}
		*/

		if (mutation.addedNodes.length > 0) {
			me._throttledBootstrap();
		}
	},

	/**
	 * Entfernt den Lösch-Timer und entfernt dieses
	 * Element aus der _markedForDestruction-Liste
	 * @param {HTMLElement} el
	 */
	_clearDestructionMark: function (el) {
		var me = this;
		clearTimeout(me._markedForDestruction.get(el));
		me._markedForDestruction.delete(el);
	},

	/**
	 *
	 * @param {HTMLElement} el
	 */
	_updateElementBootstrappedAttributes: function (el) {
		var me = this;
		this._getAttributeNames(el)
			.filter(function (attrName, index, list) {
				// Nur Attribute "-bootstrapped"-Attribute verarbeiten
				return list.indexOf(attrName + "-bootstrapped") > -1;
			})
			.forEach(function (dataAttribute) {
				// Attribut entfernen, falls die zugehörige Instanz nicht mehr existiert
				var inst = me.getInstanceByElement(el, dataAttribute);
				if (inst === null) {
					el.removeAttribute(dataAttribute + "-bootstrapped");
				}
			});
	},

	_getAttributeNames: function (el) {
		if (el.getAttributeNames) {
			return el.getAttributeNames();
		}
		var attributes = el.attributes;
		var length = attributes.length;
		var result = new Array(length);
		for (var i = 0; i < length; i++) {
			result[i] = attributes[i].name;
		}
		return result;
	}
});
